export default "__VITE_ASSET__3724e726__"